import { render, staticRenderFns } from "./EditEmail.vue?vue&type=template&id=4b590643&scoped=true"
import script from "./EditEmail.vue?vue&type=script&lang=js"
export * from "./EditEmail.vue?vue&type=script&lang=js"
import style0 from "./EditEmail.vue?vue&type=style&index=0&id=4b590643&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b590643",
  null
  
)

export default component.exports